module.exports = __webpack_public_path__ + "media/bootstrap-icons/check2-square-c602898f.svg";